import React from 'react';
import HeroBanner from '../../components/home/HeroBanner';
import ContactUs from '../../components/home/ContactUs';
import PreviousWinners from '../../components/home/PreviousWinners';

const Home: React.FC = () => {
  return (
    <main className="home-page">
      {/* Hero Section */}
      <HeroBanner />

      {/* Previous Winners Section */}
      <section className="bg-gray-50">
        <div className="container mx-auto px-4 py-8 md:py-12">
          <PreviousWinners />
        </div>
      </section>

      {/* Contact Us Section */}
      <section>
        <ContactUs />
      </section>
    </main>
  );
};

export default Home;
